import {
  DropdownOptions,
  Flex,
  FormContext,
  LocalCashTables,
  TooltipPopup,
} from "dash-ui";
import { useTranslation } from "react-i18next";

import Properties from "containers/properties/Properties/Properties";
import DeliveryImage from "assets/images/png/Delivery.png";
import SearchingImage from "assets/images/png/Searching.png";
import {
  useGetMarketAreasQuery,
  useGetUsStatesQuery,
} from "gql/generated.graphql";
import { useContext, useMemo } from "react";
import { DownloadXmlButton } from "containers/properties/components/DownloadXmlButton/DownloadXmlButton";

function PropertiesPage() {
  const { t } = useTranslation(["tables"]);
  const { data: statesData } = useGetUsStatesQuery();
  const { formState } = useContext(FormContext);

  const statesOptions = useMemo(() => {
    const states = statesData?.getUSStates || [];
    return states.map(({ name }) => ({
      value: name,
      label: name,
    }));
  }, [statesData]);

  const { data: result } = useGetMarketAreasQuery({
    variables: {
      filter: {
        stateNames: formState.state && [formState.state],
      },
      pagination: {
        allowLimit: false,
      },
      sort: {
        fieldName: "name",
        sortOrder: 1,
      },
    },
  });

  const { marketAreas } = useMemo(
    () => ({
      marketAreas: result?.getMarketAreas?.collection || [],
    }),
    [result]
  );

  const marketOptions = useMemo(() => {
    return marketAreas.map(({ _id, name }) => ({
      value: _id,
      label: name,
    }));
  }, [marketAreas]);

  return (
    <Flex flexDirection="column" flex={1} w="100%">
      <DropdownOptions />
      <TooltipPopup />
      <Properties
        filter={{}}
        tableProps={{
          hideColumns: [],
          actionProps: { withStatusFilter: true, statesOptions, marketOptions },
          placeholder: t("tables:properties:placeholder") || "",
          placeholderImage: DeliveryImage,
          searchPlaceholder: t("tables:properties:placeholderSearch") || "",
          searchPlaceholderImage: SearchingImage,
        }}
        storageTableName={LocalCashTables.PROPERTIES}
      />

      <div className="m-4">
        <DownloadXmlButton />
      </div>
    </Flex>
  );
}

export default PropertiesPage;
